// Copyright 2015, Mike Bostock
// BSD 3-Clause License — https://github.com/d3/d3-sankey/blob/main/LICENSE
// Vendored from d3-sankey@0.12.3 — https://github.com/d3/d3-sankey

export default function constant<T>(x: T): () => T {
  return function (): T {
    return x;
  };
}
